// extracted by mini-css-extract-plugin
export var externalLink = "_ch-0";
export var internalLinkLabel = "_ch-1";